/**
 * Reads a response body as JSON, returning undefined instead of throwing when there isn't one.
 *
 * A rejected sign-in normally carries the API's JSON error body, but a 401 can also come from the
 * edge — an auth proxy or nginx — with an empty or HTML body, and `Response.json()` rejects there.
 */
export async function readJsonBody(res: Response): Promise<unknown> {
  try {
    return await res.json()
  } catch {
    return undefined
  }
}
